import type { CheckboxData, Options } from './types.tsx';

export const mapDataToOptions = (data: CheckboxData): Options =>
	data.map(({ id, value }) => ({ label: value, value: id }));

export const mapOptionsToData = (options: Options): CheckboxData =>
	options.map(({ label, value }) => ({ id: value, value: label }));
